<script>
  import { createEventDispatcher, tick, onDestroy } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import Button from '@components/Button.svelte';
  import Input from '@components/Input.svelte';
  import Link from '@components/Link.svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import Notification from '@utils/notification';
  import BootstrapDropdown from '@utils/bootstrap-dropdown';
  import GroupAjax from '@ajax/group';
  import WelcomeNoteAjax from '@ajax/welcome_note';
  import CustomScroll from '@utils/custom-scroll';

  import DuplicateListModal from './DuplicateListModal.svelte';
  import WelcomeNoteModal from './WelcomeNoteModal.svelte';
  import EmbedPostModal from './EmbedPostModal.svelte';
  import SaveRecRequestModal from '@app-components/rec_request/SaveRecRequestModal.svelte';
  import ChangeCoverPhotosModal from '@app-components/modal/ChangeCoverPhotosModal.svelte';
  import EmojiPicker from '@app-components/EmojiPicker.svelte';
  import ListSettingsToggle from '@app-components/modal/ListSettingsToggle.svelte';
  import Track from '@utils/track';

  const dispatch = createEventDispatcher();
  import jQuery from 'jquery';

  export let group;
  export let showModal = false;
  export let selectedOptionIndex = 1;
  export let mobile = false;

  let sub = group.subscribe((x) => (group = x));
  let currentUser = getCurrentUserStore('default');

  let changingUrl = false;
  let changeLinkModal = false;
  let showEmbedPostModal = false;
  let changeListInput;
  let currentLinkPath;
  let changedLinkPath = '';

  let passwordModal = false;
  let passwordInput;

  let showWelcomeNoteModal = false;
  let welcomeNoteEditMode = false;

  let showCoverPhotosModal = false;
  let showDuplicateListModal = false;
  let showAddRequestModal = false;
  let showEmojiPicker = false;
  let showPublicHiddenDropdown = false;
  let recRequestForSaveModal = {};

  let selectOption = function (idx) {
    selectedOptionIndex = idx;
  };

  let updateEmoji = async function (emoji) {
    let data = { emoji: emoji };
    group.set({ ...group, ...data });
    await GroupAjax.update(group, { emoji_id: emoji.id });
  };

  // privacy

  let togglePrivacy = async function () {
    if (group.listing_flag === 'listed' && group.privacy_flag === 'public') {
      Notification.send({
        text: 'To disable Link Sharing, first change the list to Hidden',
      });

      return;
    }

    if (group.privacy_flag == 'public') {
      group.privacy_flag = 'private';
    } else {
      group.privacy_flag = 'public';
    }

    let data = { privacy_flag: group.privacy_flag };
    group.set({ ...group, ...data });
    await GroupAjax.update(group, data);
  };

  let updateListingFlag = async function (listing_flag) {
    group.listing_flag = listing_flag;

    if (listing_flag === 'listed') {
      group.privacy_flag = 'public';
    }

    let data = {
      listing_flag: group.listing_flag,
      privacy_flag: group.privacy_flag,
    };

    group.set({ ...group, ...data });
    await GroupAjax.update(group, data);
  };

  // advanced

  let showChangeLinkModal = async function () {
    changeLinkModal = true;
    currentLinkPath = group.url.split('lists/')[1];
    await tick();
    jQuery(changeListInput).focus();
  };

  let hideChangeLinkModal = function () {
    changeLinkModal = false;
  };

  let changeUrl = async function () {
    changingUrl = true;

    try {
      let data = { slug: changeListInput.value };
      let resp = await GroupAjax.update(group, data);
      group.set(resp);
      hideChangeLinkModal();
      changedLinkPath = ''; // reset changed link path
      dispatch('url-changed', { group: resp });
    } catch (err) {
      if (err) {
        Notification.send({
          text: 'This url is already taken. Please select another one.',
          type: 'error',
        });
      }
    }

    changingUrl = false;
  };

  let toggleShowComments = async function () {
    let data = { show_comments: !group.show_comments };
    await GroupAjax.update(group, data);
    group.set({ ...group, ...data });

    Notification.send({
      text: `List comments has been ${group.show_comments ? 'enabled' : 'disabled'}`,
    });
  };

  const toggleMapView = async () => {
    let data = { map_view_enabled: !group.map_view_enabled };
    await GroupAjax.update(group, data);
    group.set({ ...group, ...data });

    Notification.send({
      text: `Map view has been ${group.map_view_enabled ? 'enabled' : 'disabled'}`,
    });
  };

  let toggleShowReviewSites = async function () {
    let data = { show_review_sites: !group.show_review_sites };
    group.set({ ...group, ...data });
    await GroupAjax.update(group, data);

    Notification.send({
      text: `Review sites have been turned ${group.show_review_sites ? 'on' : 'off'}`,
    });
  };

  let toggleShowLikes = async function () {
    let data = { show_likes: !group.show_likes };
    group.set({ ...group, ...data });
    await GroupAjax.update(group, data);

    Notification.send({
      text: `List likes has been ${group.show_likes ? 'enabled' : 'disabled'}`,
    });
  };

  let togglePasswordProtected = function () {
    if (group.password_protected) {
      setAccessPassword();
    } else {
      showPasswordModal();
    }
  };

  let showPasswordModal = function () {
    passwordModal = true;
  };

  let setAccessPassword = async function () {
    var val = '';
    var privacy_flag = group.privacy_flag;

    if (passwordInput) {
      val = passwordInput.value;
      privacy_flag = 'private';
    }

    let data = {
      password: val,
      privacy_flag: privacy_flag,
    };

    let resp = await GroupAjax.update(group, data);
    group.set(resp);
    passwordModal = false;

    if (passwordInput) {
      passwordInput.value = '';
    }
  };

  let showWelcomeNote = function (edit) {
    showWelcomeNoteModal = true;

    if (!mobile) {
      welcomeNoteEditMode = edit;
      group.set({ ...group, welcome_note_editing: true });
    }
  };

  let showEmbedPost = function () {
    showModal = false;
    showEmbedPostModal = true;
    Track.embedPostClicked({ currentUser: currentUser, group: group });
  };

  let handleEmbedPostBackButton = function () {
    showEmbedPostModal = false;
    showModal = true;
    setTimeout(CustomScroll.scrollToRequiredDivById, 100, `embed-post-setting-${group.id}`);
  };

  let toggleWelcomeNote = async function () {
    let data = { welcome_note_enabled: !group.welcome_note_enabled };
    let resp = await WelcomeNoteAjax.toggle(group, data.welcome_note_enabled);
    group.set({ ...group, ...data });

    if (resp.created) {
      showWelcomeNote(true);
    }
  };

  let close = function () {
    showEmojiPicker = false;
    showModal = false;

    dispatch('close');
  };

  onDestroy(() => {
    sub();
  });
</script>

<style style="text/scss" lang="scss">
  * :global(button:disabled) {
    opacity: 0.5;
  }

  .ui-header {
    font-weight: 500;
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    margin-top: -20px;
    margin-bottom: 46px;
    display: flex;
    align-items: center;
    justify-content: center;

    .emoji-img-container {
      padding: 14px;
      display: flex;
      align-items: center;
      cursor: pointer;

      &:hover {
        background: #f9f7ff;
        border-radius: 15px;
      }

      .emoji-img {
        width: 37px;
        height: 37px;
        flex-shrink: 0;
        margin-right: 15px;
      }

      .emoji-img-down {
        transform: scale(125%);
      }
    }
  }

  .ui-options {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 22px;
    margin-right: 22px;
    transition: 0.2s all;
    background: #f9f7ff;
    border-radius: 15px;

    .ui-option {
      flex-shrink: 0;
      text-align: center;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: black;
      cursor: pointer;
      position: relative;
    }

    .ui-option-name {
      padding: 14px;
      padding-left: 15px;
      padding-right: 15px;
      opacity: 0.5;

      &:hover {
        color: #a893f9;
        opacity: 1;
      }
    }

    .ui-option-selected {
      opacity: 1;
    }

    .ui-option-bottom-bar {
      position: absolute;
      bottom: 0px;
      width: 90px;
      height: 3px;
      background: #a893f9;
      left: calc(50% - 45px);
    }
  }

  .option-container {
    margin-top: 42px;
    margin-left: 39px;
    margin-right: 39px;
    text-align: left;

    .accept-btn {
      background: black;
      color: white;
      padding: 10px;
      font-size: 14px;
      padding-left: 15px;
      padding-right: 15px;
      border-radius: 12px;
      font-weight: 500;

      &:hover {
        opacity: 0.8;
      }
    }

    .decline-btn {
      background: #fde7e7;
      color: #ff5567;
      padding: 10px;
      font-size: 14px;
      padding-left: 15px;
      padding-right: 15px;
      border-radius: 12px;
      margin-left: 10px;
      font-weight: 500;

      &:hover {
        opacity: 0.8;
      }
    }

    .share-btn {
      display: block;
      margin-top: 50px;
      margin-left: auto;
      margin-right: auto;
      border-radius: 15px;
      width: 129px;
      height: 54px;
      line-height: 10px;
      font-size: 14px;
      font-weight: 500;
      padding-top: 15px;
      padding-bottom: 15px;
      height: 54px;
      background: white;
      color: black;
      border: 2px solid #e8e8e8;
      outline: none;
      cursor: pointer;

      &:hover {
        background: black;
        color: white;
        border: 2px solid black;
        outline: none;
      }
    }

    .checkbox-container {
      flex-shrink: 0;
      position: relative;
      display: inline-block;
      width: 60px;
      height: 32px;

      .togger-enabled {
        background-color: #a893f9 !important;
        border-color: #a893f9 !important;

        &:before {
          transform: translateX(24px) !important;
          background: white !important;
        }
      }

      .ui-toggler {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        border: 2px solid #ececec;
        border-radius: 999px;
        transition: 0.4s;

        &:before {
          position: absolute;
          content: '';
          height: 24px;
          width: 24px;
          left: 4px;
          bottom: 2px;
          background-color: #ececec;
          border-radius: 50%;
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }
      }
    }

    .input-container {
      display: flex;
      margin-top: 14px;
      position: relative;

      .link-url {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;

        border-radius: 15px;
        padding-right: 120px !important;
        margin-top: 0px;
        text-overflow: ellipsis;
        border: 2px solid #e8e8e8;
        font-weight: 500;
        line-height: 1;
        padding: 15px 21px;
        min-height: 48px;
        width: 100%;
        outline: none;
        font-size: 14px;
        vertical-align: middle;
        color: black;

        &:focus {
          background: #f6f4fe;
          border-color: transparent !important;
        }

        &:hover {
          background: #f6f4fe;
          border-color: #a893f9 !important;
        }

        &:disabled {
          background: #e8e8e8 !important;
          border-color: transparent !important;
          color: rgb(84, 84, 84);
          font-weight: normal;
          opacity: 0.9;
        }
      }

      .change-link {
        cursor: pointer;
        border: 1px solid #a893f9;
        color: #7054dc;
        background: #f8f8f8;
        position: absolute;
        width: 80px;
        align-items: center;
        font-weight: 500;
        right: 15px;
        top: 8px;
        border-radius: 8px;
      }
    }

    .preview-edit-link {
      color: #8e71ff;
      font-weight: 500;

      &:hover {
        color: #7054dc;
      }
    }

    .duplicate-list-btn {
      margin-top: 22px;
      margin-left: auto;
      margin-right: auto;
      border-radius: 15px;
      width: 170px;
      height: 54px;
      line-height: 10px;
      font-size: 14px;
      font-weight: 500;
      padding-top: 15px;
      padding-bottom: 15px;
      height: 54px;
      background: white;
      color: black;
      border: 2px solid #e8e8e8;
      outline: none;
      cursor: pointer;

      &:hover {
        background: black;
        color: white;
        border: 2px solid black;
        outline: none;
      }
    }

    .create-rec-request-btn {
      display: block;
      margin-top: 40px;
      margin-left: auto;
      margin-right: auto;
      border-radius: 15px;
      width: 170px;
      height: 54px;
      line-height: 10px;
      font-size: 14px;
      font-weight: 500;
      padding-top: 15px;
      padding-bottom: 15px;
      height: 54px;
      background: white;
      color: black;
      border: 2px solid #e8e8e8;
      outline: none;
      cursor: pointer;

      &:hover {
        background: black;
        color: white;
        border: 2px solid black;
        outline: none;
      }
    }
  }

  .mobile {
    .option-container {
      margin-left: 10px !important;
      margin-right: 10px !important;
    }

    .ui-options {
      margin-left: 0px !important;
      margin-right: 0px !important;

      .ui-option-name {
        padding-left: 10px !important;
        padding-right: 10px !important;
      }
    }
  }

  .public-hidden-dropdown {
    .public-hidden-btn {
      cursor: pointer;
      width: 60px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid #ececec;
      border-radius: 20px;

      .eye-icon {
        margin-right: 6px;
      }
    }

    .dropdown-menu {
      position: absolute;
      top: 35px;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1);
      border: 0px;
      border-radius: 12px;
      overflow: hidden;
      padding-top: 12px;
      padding-bottom: 12px;

      a {
        font-size: 14px;
        line-height: 20px;
        padding-top: 4px;
        padding-bottom: 4px;

        &.selected-item {
          font-weight: 500;

          .fa {
            visibility: visible;
          }
        }

        .fa {
          margin-right: 12px;
          color: #a893f9;
          visibility: hidden;
        }

        &:hover {
          background-color: white;
          color: #a893f9;
        }
      }
    }
  }

  :global(.list-settings-modal) {
    max-width: 580px !important;
  }

  :global(.list-settings-modal-mobile) {
    margin-top: 10px !important;
  }
</style>

<div>
  {#if showCoverPhotosModal}
    <ChangeCoverPhotosModal bind:showModal={showCoverPhotosModal} mobile={mobile} group={group} user={currentUser} />
  {/if}
  {#if showEmbedPostModal}
    <EmbedPostModal
      bind:showModal={showEmbedPostModal}
      mobile={mobile}
      group={group}
      currentUser={currentUser}
      on:back-button-click={handleEmbedPostBackButton} />
  {/if}

  <Modal
    containerClass={mobile ? 'list-settings-modal-mobile' : 'list-settings-modal'}
    mobile={mobile}
    on:close={close}
    show={showModal}
    showCloseButton={true}
    fadeInDuration={200}>
    <div
      slot="content"
      on:click={() => {
        showEmojiPicker = false;
        showPublicHiddenDropdown = false;
      }}
      style="text-align: center;"
      class:mobile={mobile}>
      <div class="ui-header" style="flex-direction: column;">
        <div class="emoji-img-container" on:click|stopPropagation={() => (showEmojiPicker = true)}>
          <img class="emoji-img" alt="{group.emoji.name} emoji" src={group.emoji.outside_src} />
          <div>
            <img src="/images/share-modal/down.svg" class="emoji-img-down" />
          </div>
        </div>

        {#if showEmojiPicker}
          <div
            style="z-index: 2; position: absolute; width: 100%; left: 0px; right: 0px; display: flex; justify-content: center; margin-top: 30px;">
            <EmojiPicker
              mobile={mobile}
              on:emoji-selected={(e) => {
                showEmojiPicker = false;
                updateEmoji(e.detail.emoji);
              }} />
          </div>
        {/if}

        <div style="font-weight: 500; font-size: 20px; line-height: 28px; margin-top: 4px;">
          {group.name}
        </div>
      </div>

      <div class="ui-options">
        <div
          class="ui-option"
          on:click={() => {
            selectOption(1);
          }}
          style="flex: 1">
          <div class:ui-option-name={true} class:ui-option-selected={selectedOptionIndex == 1}>Privacy Settings</div>
          {#if selectedOptionIndex == 1}
            <div class="ui-option-bottom-bar" />
          {/if}
        </div>
        <div
          class="ui-option"
          on:click={() => {
            selectOption(2);
          }}
          style="flex: 1">
          <div class:ui-option-name={true} class:ui-option-selected={selectedOptionIndex == 2}>Advanced Settings</div>
          {#if selectedOptionIndex == 2}
            <div class="ui-option-bottom-bar" />
          {/if}
        </div>
      </div>

      <div class="option-container">
        {#if selectedOptionIndex == 1}
          <div>
            <div style="display: flex;">
              <div class="public-hidden-dropdown dropdown" use:BootstrapDropdown.setup>
                <span data-bs-toggle="dropdown">
                  <div
                    on:click|stopPropagation={() => (showPublicHiddenDropdown = !showPublicHiddenDropdown)}
                    class="public-hidden-btn">
                    <img
                      src="/images/share-modal/hidden.svg"
                      class="eye-icon"
                      style={group.listing_flag === 'unlisted' ? '' : 'display: none'} />

                    <img
                      src="/images/share-modal/visible.svg"
                      class="eye-icon"
                      style={group.listing_flag === 'listed' ? '' : 'display: none'} />

                    <img
                      src="/images/share-modal/down.svg"
                      class="down-arrow"
                      style={showPublicHiddenDropdown ? 'transform: rotate(180deg);' : ''} />
                  </div>
                </span>
                <ul class="dropdown-menu {showPublicHiddenDropdown ? 'show' : ''}">
                  <li>
                    <a
                      href="#"
                      on:click|preventDefault={() => updateListingFlag('unlisted')}
                      class:selected-item={group.listing_flag == 'unlisted'}>
                      <span class="fa fa-check" />
                      <span>Hidden list</span>
                    </a>

                    <a
                      href="#"
                      on:click|preventDefault={() => updateListingFlag('listed')}
                      class:selected-item={group.listing_flag == 'listed'}>
                      <span class="fa fa-check" />
                      <span>Public list</span>
                    </a>
                  </li>
                </ul>
              </div>

              <div style="margin-left: 24px;">
                {#if group.listing_flag == 'listed'}
                  <div style="font-weight: 500; font-size: 14px; line-height: 20px;">Public list</div>
                  <div style="font-size: 14px; line-height: 20px; margin-top: 8px; color: #7F7F7F;">
                    List will be publicly visible on your profile and appear in search results
                  </div>
                {:else}
                  <div style="font-weight: 500; font-size: 14px; line-height: 20px;">Hidden list</div>
                  <div style="font-size: 14px; line-height: 20px; margin-top: 8px; color: #7F7F7F;">
                    List will <u>not</u> be publicly visible on your profile nor appear in search results
                  </div>
                {/if}
              </div>
            </div>
            <div style="margin-top: 32px; display: flex;">
              <div class="checkbox-container">
                <span
                  on:click={togglePrivacy}
                  class="ui-toggler"
                  class:togger-enabled={group.privacy_flag == 'public'} />
              </div>

              <div style="margin-left: 24px">
                <div style="font-weight: 500; font-size: 14px; line-height: 20px;">Link sharing</div>
                <div style="font-size: 14px; line-height: 20px; color: #7F7F7F; margin-top: 8px;">
                  Allows people with the link to view the contents of this list
                </div>
              </div>
            </div>
          </div>
        {/if}

        {#if selectedOptionIndex == 2}
          <div class="svelte-list-settings-modals">
            <Modal
              mobile={mobile}
              on:close={() => {
                passwordModal = false;
              }}
              show={passwordModal}
              showCloseButton={true}
              fadeInDuration={200}>
              <div slot="header">Set password</div>
              <div slot="content">
                <div>
                  <Input
                    bind:inputEl={passwordInput}
                    label="Enter a password to access the list"
                    value={group.password} />
                </div>
                <div style="margin-top: 20px; display: flex; justify-content: center;">
                  <Button text="Set password" style="width: 230px" on:click={setAccessPassword} />
                </div>
              </div>
            </Modal>

            <Modal
              mobile={mobile}
              on:close={() => {
                changeLinkModal = false;
              }}
              show={changeLinkModal}
              showCloseButton={true}
              fadeInDuration={200}>
              <div slot="header">Change List URL</div>
              <div slot="content">
                <div
                  style=" margin-top: 20px; margin-bottom: 20px; line-height: 26px;
              padding-top: 20px; border-top: 1px solid #ececec; border-bottom:
              1px solid #ececec; padding-bottom: 20px; opacity: 0.75;">
                  This will change the link to access the list. Any previous link that you may have already shared will
                  still work to access this list as well!
                </div>

                <div style="display: flex; padding-top: 20px;">
                  <span style="flex-shrink: 0; padding-top: 7px;">
                    https://benable.com/{currentUser.username_or_id}/
                  </span>
                  <input
                    type="text"
                    bind:value={changedLinkPath}
                    bind:this={changeListInput}
                    style="margin-left: 10px; width: 100%;"
                    placeholder={currentLinkPath} />
                </div>

                <div style="margin-top: 35px; text-align: center;">
                  <Button
                    text="Change Link"
                    loading={changingUrl}
                    style="width: 230px;"
                    on:click={changeUrl}
                    disabled={changedLinkPath.length === 0} />
                </div>
              </div>
            </Modal>
          </div>

          <SaveRecRequestModal
            on:close={() => {
              recRequestForSaveModal = {};
            }}
            recRequest={JSON.parse(JSON.stringify(recRequestForSaveModal))}
            bind:showModal={showAddRequestModal}
            group={group}
            currentUser={currentUser} />

          {#if showWelcomeNoteModal}
            <WelcomeNoteModal
              group={group}
              mobile={mobile}
              currentUser={currentUser}
              on:close={() => {
                showWelcomeNoteModal = false;
              }}
              bind:edit={welcomeNoteEditMode} />
          {/if}

          <DuplicateListModal
            on:success={(e) => {
              dispatch('duplicate', e.detail);
            }}
            mobile={mobile}
            bind:showModal={showDuplicateListModal}
            group={group} />

          <div>
            {#if currentUser.show_cover_photos_for_groups}
              <div
                style="border-bottom: 1px solid #eee; padding-bottom: 30px;
            font-size: 15px; margin-bottom: 20px; display: flex;">
                <div style="flex: 1; font-weight: 500;">Cover photos</div>
                <Link text="Edit photos" style="font-weight: 500;" on:click={() => (showCoverPhotosModal = true)} />
              </div>
            {/if}

            <div
              style="border-bottom: 1px solid #eee; padding-bottom: 30px;
            font-size: 14px; margin-bottom: 20px;">
              <div style="font-weight: 500;">List url</div>

              <div class="input-container">
                <input class="link-url" type="text" value={group.url} readonly="readonly" />
                <button class="change-link" on:click={showChangeLinkModal}> Change </button>
              </div>
            </div>

            <ListSettingsToggle
              title={'Show comments'}
              togglerEnabled={group.show_comments}
              on:toggle={toggleShowComments} />

            <ListSettingsToggle title={'Show likes'} togglerEnabled={group.show_likes} on:toggle={toggleShowLikes} />

            <ListSettingsToggle
              title={'Show review sites'}
              togglerEnabled={group.show_review_sites}
              endOfSection={true}
              on:toggle={toggleShowReviewSites} />

            <ListSettingsToggle
              title={'Password protect this list'}
              description={'You can allow visitors with a password to access your list. This will make the list private.'}
              togglerEnabled={group.password_protected}
              simple={false}
              endOfSection={true}
              on:toggle={togglePasswordProtected}>
              <span slot="description-action">
                {#if group.password_protected}
                  <a href="#" style="color: #8e71ff; font-weight: 400" on:click|preventDefault={showPasswordModal}>
                    [change password]
                  </a>
                {/if}
              </span>
            </ListSettingsToggle>

            <ListSettingsToggle
              title={'Welcome note'}
              description={'Add a customizable welcome note to your list, with your branding and colors.'}
              togglerEnabled={group.welcome_note_enabled}
              simple={false}
              endOfSection={true}
              on:toggle={toggleWelcomeNote}>
              <div slot="title-action">
                {#if group.welcome_note_enabled}
                  <div style="margin-left: 30px;">
                    <a
                      href="#"
                      on:click|preventDefault={() => {
                        showWelcomeNote(false);
                      }}
                      class="preview-edit-link">
                      Preview & Edit
                    </a>
                  </div>
                {/if}
              </div>
            </ListSettingsToggle>
            {#if currentUser.list_embedding_enabled}
              <div id="embed-post-setting-{group.id}">
                <ListSettingsToggle
                  title={'Embed post'}
                  description={'Embed a post from Instagram or TikTok'}
                  progress={true}
                  endOfSection={true}
                  simple={false}
                  on:clicked={showEmbedPost} />
              </div>
            {/if}
            {#if currentUser.can_enable_map_view}
              <ListSettingsToggle
                title={'Enable map view'}
                description={'Allow viewers to browse location-based recommendations on an interactive map.'}
                togglerEnabled={group.map_view_enabled}
                simple={false}
                endOfSection={true}
                on:toggle={toggleMapView} />
            {/if}

            <div
              style="padding-bottom: 30px; margin-bottom: 20px; border-bottom: 1px
            solid rgb(238, 238, 238); display: flex; align-items: center;">
              <button
                class="duplicate-list-btn"
                on:click={() => {
                  showDuplicateListModal = true;
                }}>
                Duplicate list
              </button>
            </div>

            {#if !mobile && group.permissions.create_rec_request}
              <button
                class="create-rec-request-btn"
                on:click={() => {
                  showAddRequestModal = true;
                }}>
                Create rec request
              </button>
            {/if}
          </div>
        {/if}
      </div>
    </div>
  </Modal>
</div>
